<template>
  <loading v-if="loading" />

  <div id="wrapper" class="noheader">
    <div class="content appointment">
      <div class="caption">
        <div class="inner">
          <span></span>
          <p>就診報到</p>
          <span></span>
        </div>
        <a class="arr" @click.prevent="$router.replace('/HomePage')"
          ><div class="inner"></div
        ></a>
      </div>
      <div class="appointmentBox addbottom" v-if="!appointments.length">
        <div class="box title">
          <div><span>掛號內容</span></div>
          <div><span>預約序號</span></div>
          <div><span>&nbsp;</span></div>
        </div>
        <div class="box">
          <div><p>您今日無預約可供報到。</p></div>
        </div>
      </div>
      <!--今日有預約可報到-->
      <div class="appointmentBox" v-if="appointments.length">
        <div class="box title">
          <div><span>掛號內容</span></div>
          <div><span>&nbsp;</span></div>
          <div><span>預約序號</span></div>
        </div>
        <div class="box" v-for="(a, idx) in appointments" :key="idx">
          <div>
            <span>{{ a.日期 }}&nbsp;{{ a.診別 }}&nbsp;{{ a.班別 }}診</span>
            <p>{{ a.科別 }}&nbsp;{{ a.醫師名 }}&nbsp;醫師</p>
            <div class="patient">{{ a.name }} {{ a.patientNo }}</div>
          </div>
          <div><span>&nbsp;</span></div>
          <div class="number">{{ a.掛號序號 }}</div>
        </div>
        <div class="bookInfoBox" style="margin-top: 2rem;">
          <div class="qrcodeBox">
            <p class="txt">報到時請至一樓或三樓櫃台出示 QRCODE</p>
            <img :src="qrcode" />
          </div>
        </div>
        <p class="appointmentTxt">
          請注意看診進度，如您初次至木生看診，<br />請準備身分證字號方便建立病歷。
        </p>
      </div>
    </div>
  </div>

  <modal v-if="modal.display" @close="modal.display = false">
    <template v-slot:header v-if="modal.header">{{ modal.header }}</template>
    <template v-slot:body>{{ modal.body }}</template>
  </modal>

  <debug v-if="debug">{{ member }}</debug>
</template>

<script>
import api from "../api/index";
export default {
  data() {
    return {
      debug: eval(process.env.VUE_APP_DEBUG),
      loading: true,
      modal: {},
      appointments: [],
      qrcode: null
    };
  },
  created() {
    this.getAppointments();
    this.genQRCode();
  },
  computed: {
    member() {
      return this.$store.state.member;
    }
  },
  methods: {
    getAppointments() {
      api.appointment
        .query({
          jwt: this.member.jwt
        })
        .then(data => {
          console.log(data);
          this.loading = false;
          this.appointments = data.appointments.filter(a => a.today);
        })
        .catch(error => {
          this.loading = false;
          this.modal = {
            display: true,
            header: "網路連線異常",
            body: error.message
          };
        });
    },
    genQRCode() {
      api.visit.liff
        .generate({
          jwt: this.member.jwt
        })
        .then(qrcode => {
          console.log(qrcode);
          this.loading = false;
          this.qrcode = qrcode;
        })
        .catch(error => {
          this.loading = false;
          this.modal = {
            display: true,
            header: "網路連線異常",
            body: error.message
          };
        });
    },
    btnCancel(appointment) {
      //console.log(appointment);
      this.loading = true;
      api.appointment
        .cancel({
          jwt: this.member.jwt,
          appointment
        })
        .then(data => {
          console.log(data);
          this.getAppointments(); //重新讀取
        })
        .catch(error => {
          this.loading = false;
          this.modal = {
            display: true,
            header: "網路連線異常",
            body: error.message
          };
        });
    }
  }
};
</script>

<style scoped>
.patient {
  padding-top: 0.3rem;
  font-size: 0.8rem;
  color: grey;
}
</style>
